import React, { useRef, useState } from 'react';
import { TOOLTIP_PLACEMENTS, TootltipBox } from './tooltip-box';
import './tooltip.scss';

export enum TOOLTIP_VARIANTS {
    INFO = 'info-tooltip',
    WARNING = 'warning-tooltip',
    ERROR = 'error-tooltip',
    SUCCESS = 'success-tooltip',
    TEXT = 'text-tooltip'
}

export interface ITooltipProps {
    children: React.ReactNode,
    placement?: TOOLTIP_PLACEMENTS,
    variant?: TOOLTIP_VARIANTS,
    showOnClick?: boolean,
    content: React.ReactNode,
}

export const Tooltip: React.FC<ITooltipProps> = ({ 
    children, 
    placement, 
    variant = TOOLTIP_VARIANTS.INFO, 
    showOnClick = false,
    content
}) => {
    let [showTooltip, setShowTooltip] = useState(false);

    const refrerence = useRef<HTMLSpanElement>(null);

    const onPointerLeave = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        if (showOnClick) {
            return;
        }
        setShowTooltip(false);
    }

    const onPointerOver = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        if (showOnClick) {
            return;
        }
        setShowTooltip(true);
    }

    const onMouseClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        if (!showOnClick) {
            return;
        }
        e.stopPropagation();
        setShowTooltip(!showTooltip);
    }

    return (
        <>
            <span 
                onPointerOver={onPointerOver}
                onPointerLeave={onPointerLeave}
                onClick={onMouseClick}
                className='tootltip-holder' 
                ref={refrerence}>
                {
                    showTooltip && !!content && (
                        <TootltipBox
                          placement={placement}
                          variant={variant}
                          content={content}
                          refElement={refrerence.current}
                          showOnClick={showOnClick}
                          clickHandler={() => {setShowTooltip(false)}}
                        />
                    )
                }
                    {children}
            </span>

        </>
    );    
}
